/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const scopes = [
  'openid',
  'email',
  'profile',
  'pid:user_profile.configuration:read',
  'pid:user_profile.porscheid:read',
  'pid:user_profile.name:write',
  'pid:user_profile.name:read',
  'pid:user_profile.poo:write',
  'pid:user_profile.poo:read',
  'pid:user_profile.vehicles:write',
  'pid:user_profile.vehicles:read',
  'pid:user_profile.vehicles:delete',
  'pid:user_profile.addresses:write',
  'pid:user_profile.addresses:read',
  'pid:user_profile.addresses:delete',
  'pid:user_profile.tmp_addresses:read',
  'pid:user_profile.dealers:write',
  'pid:user_profile.dealers:read',
  'pid:user_profile.dealers:delete',
  'pid:user_profile.emails:write',
  'pid:user_profile.emails:read',
  'pid:user_profile.emails:delete',
  'pid:user_profile.phones:write',
  'pid:user_profile.phones:read',
  'pid:user_profile.phones:delete',
  'pid:user_profile.birthdate:write',
  'pid:user_profile.birthdate:read',
  'pid:user_profile.locale:write',
  'pid:user_profile.locale:read',
  'pid:user_profile.completion_rate:read',
  'pid:user_profile.profile:write',
  'pid:user_profile.terminated_vehicles:read',
  'pid:account.mfa:read',
  'pid:user_profile:invite',
]
